import {
  hasNoDefaultLocation,
  initiLocationValueFromHistory,
} from '@/features/searchV2/components/AutoSuggest/LocationAutoSuggest/LocationAutoSuggest.helpers';
import { LocationSuggestion } from '@/features/searchV2/components/AutoSuggest/LocationAutoSuggest/LocationAutoSuggest.types';
import { useEffect, useState } from 'react';

export function useShouldPromptLocation(): {
  shouldPrompt: boolean;
  isChecking: boolean;
  resolvedLocation: LocationSuggestion | null;
} {
  const [shouldPrompt, setShouldPrompt] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [resolvedLocation, setResolvedLocation] = useState<LocationSuggestion>(null);

  useEffect(() => {
    async function check() {
      try {
        if (hasNoDefaultLocation()) {
          setShouldPrompt(false);
          setIsChecking(false);
          return;
        }

        const suggestion = await initiLocationValueFromHistory();

        if (suggestion?.label) {
          setResolvedLocation(suggestion);
          setShouldPrompt(false);
          return;
        }

        setShouldPrompt(true);
      } finally {
        setIsChecking(false);
      }
    }

    check();
  }, []);

  return { shouldPrompt, isChecking, resolvedLocation };
}
